class LeaveWordSaveDto {
    title
    content
    display = 'false'
    imageUrls = []

    static getRules() {
        return {
            title: [{required: true, message: '请输入留言标题', trigger: 'onBlur'}],
            content: [{required: true, message: '请输入留言详情', trigger: 'onBlur'}],
        }
    }

    /**
     * 添加图片路径
     * @param imageList 图片列表对象
     */
    setImageUrlByImageList(imageList) {
        this.imageUrls = [];
        imageList
            .filter(image => image.status === 'done')
            .forEach(image => this.imageUrls.push(image.imageUrl));
    }
}

export default LeaveWordSaveDto